import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/auth',
    name: 'Auth',
    component: () => import(/* webpackChunkName: "Auth" */ '../views/Auth.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "Home" */ '../views/Home.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () =>
      import(/* webpackChunkName: "About" */ '../views/About.vue')
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: () =>
      import(/* webpackChunkName: "Calendar" */ '../views/Calendar.vue')
  },
  {
    path: '/journals',
    name: 'Journals',
    component: () =>
      import(/* webpackChunkName: "Journals" */ '../views/Journals.vue')
  },
  {
    path: '/tools',
    name: 'Tools',
    component: () =>
      import(/* webpackChunkName: "Tools" */ '../views/Tools.vue')
  },
  {
    path: '/:dictName',
    name: 'Dict',
    props: true,
    component: () => import(/* webpackChunkName: "Dict" */ '../views/Dict.vue')
  },
  {
    path: '/dict/:dictName',
    name: 'Dicts',
    props: true,
    component: () => import(/* webpackChunkName: "Dict" */ '../views/Dict.vue')
  },
  {
    path: '/EPL/:id',
    name: 'EPL',
    props: true,
    component: () => import(/* webpackChunkName: "EPL" */ '../views/EPL.vue')
  },
  {
    path: '/EPL/:id/:taskid',
    name: 'EPLt',
    props: true,
    component: () => import(/* webpackChunkName: "EPL" */ '../views/EPL.vue')
  },
  {
    path: '/:dictName/:id',
    name: 'DictEditForm',
    props: true,
    component: () =>
      import(/* webpackChunkName: "DictEditForm" */ '../views/DictEditForm.vue')
  },
  {
    path: '/dict/:dictName/:id',
    name: 'DictsEditForm',
    props: true,
    component: () =>
      import(/* webpackChunkName: "DictEditForm" */ '../views/DictEditForm.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
